interface Reminder {
  name: string;
  when: string;
  what: string;
}

/**
 * What the organizer will send you, and when.
 *
 * Read-only on purpose. The three reminders are scheduled server-side and there
 * is no preferences endpoint yet, so rendering toggles here would mean controls
 * that silently change nothing — worse than no controls at all. When the prefs
 * endpoint lands this becomes the form; until then it is an honest description.
 */
const REMINDERS: readonly Reminder[] = [
  {
    name: 'Morning digest',
    when: 'Every day at 08:15 (Brussels)',
    what: 'An email with what is overdue, what is due today, and how many call to-dos are waiting for review.',
  },
  {
    name: 'Reminders you set',
    when: 'At the exact time you pick',
    what: 'A Slack DM at the moment you picked, to the minute. Set one on any task from its detail panel.',
  },
  {
    name: 'Due & overdue nudges',
    when: 'Hourly',
    what: 'A Slack DM when something falls due or slips past its date. Once per task per day, never repeated.',
  },
  {
    name: 'Call to-do extraction',
    when: 'Every 30 minutes',
    what: 'Checks Fathom for new recordings and puts anything you committed to into Suggested for review.',
  },
];

/**
 * The organizer's reminders as a compact list for Settings › Notifications.
 * They run automatically and only ever reach your own inbox and Slack DMs;
 * per-reminder switches are not built yet, but every send is logged server-side.
 */
export function ReminderSettingsCard() {
  return (
    <div className="divide-y divide-border-light">
      {REMINDERS.map((reminder) => (
        <div key={reminder.name} className="flex flex-col gap-0.5 py-3 first:pt-0 last:pb-0">
          <div className="flex flex-wrap items-baseline gap-x-2">
            <h4 className="text-body-sm font-medium text-text-primary">{reminder.name}</h4>
            <span className="text-body-xs text-text-tertiary">{reminder.when}</span>
          </div>
          <p className="text-body-xs text-text-tertiary">{reminder.what}</p>
        </div>
      ))}
    </div>
  );
}
